import { Assessor } from "@/schema/console/assessors/Assessor";
import { atom, useAtomValue, useSetAtom } from "jotai";

type DialogAtom = {
  assessor?: Assessor;
  type: "" | "create" | "update" | "delete" | "change-password" | "assign-company";
};

const dialogAtom = atom<DialogAtom>({
  assessor: undefined,
  type: "",
});
const assessorAtom = atom((get) => get(dialogAtom).assessor);
const typeAtom = atom((get) => get(dialogAtom).type);

function useAssessorDialog() {
  const setDialog = useSetAtom(dialogAtom);
  const assessor = useAtomValue(assessorAtom);
  const type = useAtomValue(typeAtom);
  const resetDialog = () => setDialog({ assessor: undefined, type: "" });

  return {
    type,
    assessor,
    setDialog,
    resetDialog,
  };
}

export default useAssessorDialog;
